const gql = require("graphql-tag");

const USER_CREATE = gql`
  mutation($data: UserCreateInput) {
    userCreate(data: $data) {
      id
      username
      name
      surname
    }
  }
`;

const LOGIN = gql`
  mutation($username: String!, $password: String!) {
    login(data: { username: $username, password: $password }) {
      token
    }
  }
`;

const FORGOT_PASS = gql`
  mutation($username: String!) {
    forgotPass(username: $username)
  }
`;

const CHANGE_PASS = gql`
  mutation($data: ChangePassInput) {
    changePass(data: $data)
  }
`;

export const userMutations = {
  USER_CREATE,
  LOGIN,
  FORGOT_PASS,
  CHANGE_PASS,
};
